<template>
  <Flex
    direction="column"
    padding
  >
    <Customer
      :customer="customer"
      :loading="loading"
      :ctaTextDefault="$t(`global.actions.add_to_${orderKey()}`)"
      :ctaTextCreate="$t(`global.actions.add_to_${orderKey()}_and_create`)"
      @submit="addCustomer"
      @remove="removeCustomer"
      v-test="'sale-customer'"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import Customer from '@/components/customer/index.vue';
import type { Customer as CustomerType } from '@/components/customer/types';
import { compliantKey, orderKey } from '@/helpers/compliant-register';
import { flash, modal } from '@/helpers/ui';
import { useCustomerActions } from '@/modules/register/actions/customer';

const {
  addCustomer: addCustomerAction,
  removeCustomer: removeCustomerAction,
  loading,
} = useCustomerActions();

const { t } = useI18n();

const props = defineProps<{
  customer: any;
  orderId: string;
}>();

const emit = defineEmits(['updated']);

const addCustomer = (customer: CustomerType) => {
  addCustomerAction(props.orderId, customer.id).then((order) => {
    flash(t(compliantKey('global.flash.order_updated')));
    emit('updated', order.customer);
  });
};

const removeCustomer = () => {
  modal('confirmation', {
    message: t('register.invoice.customer_remove_confirmation'),
  }).then(() => {
    removeCustomerAction(props.orderId).then(() => {
      flash(t(compliantKey('global.flash.order_updated')));
      emit('updated', null);
    });
  });
};
</script>
